import { QuestionTypesNames } from 'models/question-type';
export const getQuestions = (questions) => {
    return questions.filter(question => !isMiddleScreen(question));
};
export const getQuestionCount = (questions) => {
    return questions.filter(question => !isMiddleScreen(question)).length;
};
export const getQuestionIndex = (questions, index, sufix = '') => {
    const question = questions[index];
    if (isMiddleScreen(question)) {
        return '';
    }
    const slicedQuestions = questions.slice(0, index);
    const msQuestions = slicedQuestions.filter(item => isMiddleScreen(item));
    return `${index + 1 - msQuestions.length}${sufix}`;
};
export const isMiddleScreen = (question) => {
    return question.questionType.typeName === QuestionTypesNames.MIDDLE_SCREEN;
};
export const filterDisplayOnExamNavigation = (questions) => {
    return questions.filter(question => question.displayOnExamNavigation);
};
